import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../../lib/api";

export const SITE = "https://stripwisepays.com";
export const trackLink = (page) => `${SITE}/chat?src=fb_${page?.slug || "main"}`;
export const localToday = () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);
export const shiftDay = (d, n) => { const x = new Date(`${d}T12:00:00`); x.setDate(x.getDate() + n); return x.toISOString().slice(0, 10); };
export const toIso = (date, time) => (date && time ? new Date(`${date}T${time}`).toISOString() : "");
export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return isNaN(d) ? "" : new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};
export const fromLocalInput = (v) => (v ? new Date(v).toISOString() : "");

export const inp = "w-full rounded-lg border border-[#dcebe8] bg-white px-3 py-2 text-[14px] outline-none transition-colors focus:border-[#0e8c7f] focus:ring-2 focus:ring-[#0e8c7f]/15";
export const card = "rounded-2xl border border-[#e3ecea] bg-white p-4 md:p-5";
export const btn = "inline-flex items-center gap-1.5 rounded-full border border-[#cfe3df] bg-white px-3 py-1.5 text-[13px] font-semibold text-[#0f2e2a] transition-colors hover:border-[#0e8c7f] hover:text-[#0e8c7f] disabled:opacity-50";
export const btnMain = "inline-flex items-center gap-1.5 rounded-full bg-[#0e8c7f] px-4 py-2 text-[13.5px] font-semibold text-white transition-colors hover:bg-[#0b6f65] disabled:opacity-50";

export const copyText = async (text, msg = "Copied") => {
  try { await navigator.clipboard.writeText(text || ""); }
  catch {
    const ta = document.createElement("textarea");
    ta.value = text || ""; document.body.appendChild(ta); ta.select();
    try { document.execCommand("copy"); } catch { /* ignore */ }
    document.body.removeChild(ta);
  }
  toast.success(msg);
};

// Fills {phone} {whatsapp} {email} {website} {chat_link} {page} {name} placeholders.
export const fillTemplate = (text, c, page, name = "") => (text || "")
  .replaceAll("{phone}", c?.phone_display || "")
  .replaceAll("{whatsapp}", c?.whatsapp_display || "")
  .replaceAll("{email}", c?.email || "")
  .replaceAll("{website}", SITE.replace("https://", ""))
  .replaceAll("{chat_link}", trackLink(page))
  .replaceAll("{page}", page?.name || "")
  .replaceAll("{name}", name || "there");

export const Label = ({ t, children, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="mb-1 block text-[12px] font-semibold uppercase tracking-wide text-[#6b7c79]">{t}</span>
    {children}
  </label>
);

export const Empty = ({ children, testid }) => (
  <div className="rounded-2xl border border-dashed border-[#cfe3df] bg-white/60 p-8 text-center text-[14px] text-[#6b7c79]" data-testid={testid}>{children}</div>
);

export const PageSelect = ({ pages, value, onChange, testid, allowAll }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} className={inp} data-testid={testid}>
    {allowAll ? <option value="">All pages</option> : <option value="">Choose page…</option>}
    {pages.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
  </select>
);

// CRUD hook for /api/admin/fb/{kind}. update(id, changes, persist) updates locally, then saves.
export const useFb = (kind) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(() => api.get(`/admin/fb/${kind}`).then(({ data }) => setItems(data))
    .catch(() => toast.error("Could not load")).finally(() => setLoading(false)), [kind]);
  useEffect(() => { reload(); }, [reload]);
  const add = async (body) => {
    const { data } = await api.post(`/admin/fb/${kind}`, body);
    setItems((x) => [...x, data]);
    return data;
  };
  const update = async (id, changes, persist = true) => {
    setItems((x) => x.map((i) => (i.id === id ? { ...i, ...changes } : i)));
    if (!persist) return;
    try {
      const { data } = await api.put(`/admin/fb/${kind}/${id}`, changes);
      const keep = Object.fromEntries([...Object.keys(changes), "reminder_sent", "slug"].filter((k) => k in data).map((k) => [k, data[k]]));
      setItems((x) => x.map((i) => (i.id === id ? { ...i, ...keep } : i)));
    } catch { toast.error("Save failed"); }
  };
  const remove = async (id) => {
    if (!window.confirm("Delete this?")) return;
    await api.delete(`/admin/fb/${kind}/${id}`);
    setItems((x) => x.filter((i) => i.id !== id));
    toast.success("Deleted");
  };
  return { items, setItems, loading, reload, add, update, remove };
};
